import './core';

export * from './configuration';

export const resources = 'capability-ng-favorites';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-favorites/src/main.ts